const HAIR_CATEGORIES = {
  HAIR_CARE: 'Hair Care',
  HAIR_STYLING: 'Hair Styling',
  HAIR_COLOR: 'Hair Color',
};

export default HAIR_CATEGORIES;
